<template>
  <div id="app">

    <!--<div id="nav">-->
      <!--<router-link to="/">Home</router-link> |-->
      <!--<router-link to="/about">About</router-link>-->
    <!--</div>-->
    <Welcome v-if="isMobile && ! showRouter" @route-change="onRouteChange" @welcome-click="onWelcomeClick"></Welcome>
    <router-view v-if="showRouter"/>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import Welcome from './views/welcome/Welcome.vue';
export default {
  components: {Welcome},
  data () {
    return {
      showRouter: true
    }
  },
  mounted () {
    this.showRouter = ! this.isMobile;
    console.log(this.isMobile);
    console.log(this.showRouter);
  },
  methods: {
    onWelcomeClick () {
      this.showRouter = true;
    },
    onRouteChange () {
      this.showRouter = true;
    }
  },
  computed: {
    ...mapGetters(['isMobile'])
  },
  watch: {
    isMobile: function () {
      console.log(this.isMobile);
      this.showRouter = ! this.isMobile;
    }
  }
}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  width: 100%;
  /*min-width: 1366px;*/
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
    html {
        height: 100%;
        width: 100%;
        /*min-width: 1366px;*/
    }
    body {
        height: 100%;
        width: 100%;
        margin: 0;
        /*min-width: 1366px;*/
    }

.news-title {
  overflow:hidden;
  text-overflow:ellipsis;
  display:-webkit-box;
  -webkit-line-clamp:2;
  -webkit-box-orient:vertical;
  cursor: pointer;
  text-align: left;
}
.news-summary {
    font-size: 15px;
    line-height: 25px;
    overflow:hidden;
    text-overflow:ellipsis;
    display:-webkit-box;
    -webkit-line-clamp:5;
    -webkit-box-orient:vertical;
    text-align: left;
}

</style>
